<template lang="pug">
  #app(v-cloak)
    transition(
      name="fade",
      mode="out-in"
      )
      router-view
    bottom-navbar(
      :isAuthenticated="memberInfo.isAuthenticated",
      :memberInfo="memberInfo"
    )
</template>

<script>
import bottomNavbar from './components/BottomNavbar';
import {mapState} from 'vuex'
export default {
  name: 'app',
  components:{
    bottomNavbar //先暫時隱藏的底部導航欄
  },
  computed:{
    ...mapState({
      memberInfo: 'memberInfo',
    })
  }
}
</script>

<style lang="scss">
  
</style>
